import { Controller } from "@hotwired/stimulus";

// Reçu de commande — GÉNÉRIQUE (shared/payments/_order_receipt).
//
// Tant que le paiement attend la validation sur le téléphone, on interroge le
// statut toutes les 4 s et on affiche le temps écoulé ; au-delà de `patience`
// secondes, on montre l'aide « rien reçu ? ». Dès que le statut change, la page
// se recharge pour afficher le nouvel état (payé, crédité, échoué).
// Une commande payée qui attend la validation GO4S est surveillée plus
// lentement (`watch`, 15 s) : le reçu passe seul à « crédité » une fois validée.
export default class extends Controller {
  static targets = ["elapsed", "stillWaiting"];
  static values = { url: String, state: String, pending: Boolean, watch: Boolean, startedAt: Number, patience: Number };

  connect() {
    if (this.watchValue) {
      this.poller = setInterval(() => this.check(), 15000);
      return;
    }
    if (!this.pendingValue) return;
    this.tick();
    this.clock = setInterval(() => this.tick(), 1000);
    this.poller = setInterval(() => this.check(), 4000);
  }

  disconnect() {
    clearInterval(this.clock);
    clearInterval(this.poller);
  }

  tick() {
    const seconds = Math.max(0, Math.floor(Date.now() / 1000 - this.startedAtValue));
    if (this.hasElapsedTarget) {
      const m = Math.floor(seconds / 60);
      const s = String(seconds % 60).padStart(2, "0");
      this.elapsedTarget.textContent = `${m}:${s}`;
    }
    if (this.hasStillWaitingTarget && seconds >= (this.patienceValue || 120)) {
      this.stillWaitingTarget.classList.remove("hidden");
    }
  }

  async check() {
    try {
      const res = await fetch(this.urlValue, { headers: { Accept: "application/json" } });
      const data = await res.json();
      if (data.status && data.status !== this.stateValue) {
        this.disconnect();
        window.location.reload();
      }
    } catch (_e) {
      // réseau instable : on réessaiera au prochain passage
    }
  }
}
